import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import * as api from "../../api";
import moment from "moment";
import {
  fetchRepairReasons,
  fetchRepairReasonsSelect,
} from "../../ducks/redux/actions/dashboardReducer.actions";
import SurveyReason from "../SurveyReason/index";
import "../RepairDetails/styles.css";

import { RouteComponentProps } from "react-router-dom";
import Button from "../../Button/Button";
import { CurrentRepair, ReportContactDetails } from "../../models/Repair/Repair";
import { PremisesTypeId } from "../../models/Customer/Premises";
import Address from "../../models/Customer/Address";
import CustomerName from "../../models/Customer/CustomerName";
import { WorksOrderRequest } from "../../models/WorksOrders/WorksOrderRequest";
import {
  userTypedRepairType,
  userChosenEmergencyQuestion,
  userChosenContactDetails,
  workOrderData,
  isEditState,
  userChosenContactPhone,
  userChosenRelationDetails,
  userChosenContactName,
} from "../../ducks/redux/actions/userChoices";
import {
  getDeterminedContractorDetails,
  workOrderRepairObject
} from "../../ducks/redux/actions/getAddress";
import { SurveyTypes } from "../../models/shared/Enum";
import { DeterminedContractorOptions } from "../../api";


interface SurveyDetailsProps extends RouteComponentProps<any> {
  getSorcode: string;

}

const SurveyDetails: React.FC<SurveyDetailsProps> = (props) => {
  const dispatch = useDispatch();
  //To track radio button selection for RepairProperty--Start here---
  //-----------Ends here-----------//
  enum surveyReportingMethods {
    "Telephone" = 1,
    "Email" = 2,
    "Social media" = 3,
    "Customer Self-Serve" = 4,
    "Colleague Self-Serve" = 5,
  }

  enum RepairCauseIds {
    "Complaint" = 3,
    "Technical Inspection" = 5,
    "Disrepair" = 6,
    "Right to Improve" = 7,
    "Mutual Exchange" = 8,
    "Leaseholder Improvement Request" = 9,
    "Estate Management Survey" = 10,
    "Keysafe Installation" = 11,
    "Void Survey" = 12,
    "Damp and Mould Survey" = 13,

  }

  const [errorMessage, setErrorMessage] = useState(false);
  const contractor = new Set(["PGM", "CPS"]);

  let priorityCode = 'VOI';
  let [selectedreportingMethod] = useState(
    "Colleague Self-Serve"
  );
  const { t } = useTranslation();

  

  const [isDisabled, setisDisabled] = useState(false);
  const [chosenHL, setChosenHL] = useState("");
  const [additionalInfo, setadditionalInfo] = useState("");
  const [surveyReasonval, setsurveyReasonval] = useState("");
  const [locatioAlert, setLocatioAlert] = useState<string[]>([]);
  const [valQuestion, setValQuestion] = useState<boolean>(false);
  const [contractorName, setContractorName] = useState<any>("");

  let alertMstArray: any[] = [];
  const addresses = useSelector(
    (state: any) => state.addresses?.customerassociatedassets
  );

  const fetchedSurveyReasons = useSelector(
    (state: any) => state.dashboardReducer.formState?.fetchedRepairReasons
  );

  const userTypedRepairReasons = useSelector(
    (state: any) => state.dashboardReducer.formState?.userTypedRepairReasons
  );
  const userChosenSurveyReason = useSelector(
    (state: any) => state.dashboardReducer.formState?.userTypedRepairReasons
  );

  const tenanciesData = useSelector(
    (state: any) => state.addresses.customertenancies
  );
  const customerDetails = useSelector(
    (state: any) => state.addresses.saveCustomerDetails
  );

  const assetId = useSelector(
    (state: any) => state?.dashboardReducer?.formState?.customerID?.assetId
  );
  const assetStatusVal = useSelector(
    (state: any) => state?.userChoicesReducer.assetDataStatus
  )

  const userChosenEmergencyQuestionVal = useSelector(
    (state: any) => state?.userChoicesReducer?.userChosenEmergencyQuestion
  );

  const priority = useSelector(
    (state: any) =>
      state?.dashboardReducer?.formState?.selectedRepairReasonPriorityOverride ??
      state?.dashboardReducer?.formState?.selectedRepairReasonObject[0]?.priority
  );

  const customerID = useSelector((state: any) => state.addresses?.customerid);

  const workOrderObject = useSelector(
    (state: any) => state.addresses.workOrderRepair
  );
  const userChosenResumeRepairValue = useSelector(
    (state: any) => state.userChoicesReducer.userChosenResumeRepair
  );

  const loadDuplicateRepairPageValue = useSelector(
    (state: any) => state.userChoicesReducer.loadDuplicateRepairPage
  );
  const getContractorname = useSelector(
    (state: any) => state.addresses.contractorname
  );
  const isCatalyst = useSelector(
    (state: any) => state.userChoicesReducer?.isCatalystProperty
  );
  const userChosenSOR = useSelector(
    (state: any) => state.userChoicesReducer.userChosenSOR
  );

  const assetDetails = useSelector(
    (state: any) =>
      state?.dashboardReducer?.formState?.assetByIdDataObject
  );
  const skipRespCheckForEMA = useSelector(
    (state: any) => state?.userChoicesReducer?.skipResponsibilityCheckForEMA
  );


  const userMaintResp = useSelector((state: any) => state.addresses.maintresp);
  const priorityKey = new Set([
    "Void Survey",
    "Keysafe Installation",
    "Damp and Mould Survey",
  ]);
  

  const ChangepriorityCode = () =>{
if (userChosenSurveyReason === "Keysafe Installation") {
    priorityCode = "KSF";
  }
  if (userChosenSurveyReason === "Void Survey") {
    priorityCode = "VOI";
  }
  if (userChosenSurveyReason === "Damp and Mould Survey") {
    priorityCode = valQuestion ? "DME" : "DMS";
  }
  if (userChosenSurveyReason && !priorityKey.has(userChosenSurveyReason)) {
    priorityCode = valQuestion ? "EME" : "NA";
  }
  }
  ChangepriorityCode();
  let emergencyState = false;
  if (assetDetails?.assetType === "Property" && priority === "Emergency") {
    if (userChosenEmergencyQuestionVal === "Yes, access can be provided") {
      emergencyState = true;
    } else {
      emergencyState = false;
    }
  } else if (priority === "Emergency" || priority === "Emergency (OOH)") {
    emergencyState = true;
  } else {
    emergencyState = false;
  }

  const workOrderSurvey = new CurrentRepair();

  const _premisesTypeId: any =
    PremisesTypeId[assetDetails?.assetType as keyof typeof PremisesTypeId];
  workOrderSurvey.repairReason = userChosenSurveyReason;
  if (surveyReasonval) {
    workOrderSurvey.description = userChosenSurveyReason + ". " + surveyReasonval;
  } else {
    workOrderSurvey.description = userChosenSurveyReason + ". " + additionalInfo;
  }
  workOrderSurvey.premisesId = assetId;
  if (assetDetails?.assetType === "Divided Block") {
    workOrderSurvey.premisesTypeId = "5";
  } else {
    workOrderSurvey.premisesTypeId = _premisesTypeId;
  }
  workOrderSurvey.customerIdentifier = customerID;
  workOrderSurvey.isEmergency = emergencyState

  workOrderSurvey.premisesUniqueReference = assetDetails?.uprn;
  const _address = new Address();
  _address.addressLine1 =
    customerDetails?.addresses?.postalAddresses[0]?.addressLine1;
  _address.addressLine2 =
    customerDetails?.addresses?.postalAddresses[0]?.addressLine2;
  _address.addressLine3 =
    customerDetails?.addresses?.postalAddresses[0]?.addressLine3;
  workOrderSurvey.premisesAddress = _address;
  workOrderSurvey.sorCode = userChosenSOR;
  workOrderSurvey.customerName = new CustomerName({
    title: customerDetails?.person?.name?.title,
    givenName: customerDetails?.person?.name?.givenName,
    surname: customerDetails?.person?.name?.surname,
  });
  workOrderSurvey.reportingMethodId =
    surveyReportingMethods[
    selectedreportingMethod as keyof typeof surveyReportingMethods
    ];
  workOrderSurvey.reportingMethod = selectedreportingMethod;

  workOrderSurvey.notifyAll = false;
  workOrderSurvey.eTag = customerDetails?.eTag; // Need to verify
  workOrderSurvey.eligibilityOutcomes = [];
  workOrderSurvey.assetIdentifier = tenanciesData?.premisesIds;
  workOrderSurvey.repairReason = userChosenSurveyReason;
  workOrderSurvey.repairLocation = "Throughout";
  workOrderSurvey.repairLocationId = "15";
  workOrderSurvey.repairCause = userChosenSurveyReason;
  workOrderSurvey.isCatalyst = isCatalyst;

  workOrderSurvey.isEmergency = valQuestion

  workOrderSurvey.additionalInformation = additionalInfo;
  workOrderSurvey.surveyReason = surveyReasonval;
  workOrderSurvey.priority = priorityCode;
  workOrderSurvey.repairType = "survey";
  workOrderSurvey.repairCauseId =
    RepairCauseIds[userChosenSurveyReason as keyof typeof RepairCauseIds];
  const _worksOrderRequest = new WorksOrderRequest(workOrderSurvey);
  const woRequestParameters = _worksOrderRequest.createWorkOrderParameter(
    workOrderSurvey
  );

  const CreateWorkOrder = async (result: boolean) => {
    try {
      dispatch(isEditState(false));
      if (!chosenHL) {
        woRequestParameters.repairReason = "";
        woRequestParameters.description = "";
      }
      woRequestParameters.sorCode = userChosenSOR
      const apiResponse = await api.createWorkOrderRepair({
        ...woRequestParameters,
      });
      if (apiResponse?.location.length > 0) {
        const workorderLocation = apiResponse?.location.split("/");
        workOrderSurvey.id = workorderLocation[4];
        workOrderSurvey.additionalInformation = additionalInfo;
        workOrderSurvey.surveyReason = surveyReasonval;
        workOrderSurvey.priority = priorityCode;
        workOrderSurvey.repairType = "survey";
        workOrderSurvey.repairReason = userChosenSurveyReason;
        workOrderSurvey.repairLocation = "Throughout";
        workOrderSurvey.repairCauseId =
          RepairCauseIds[userChosenSurveyReason as keyof typeof RepairCauseIds];
        workOrderSurvey.repairLocationId = "15";
        workOrderSurvey.worksOrderIdentifier = workorderLocation[4];
        workOrderSurvey.reporterContactDetails = new ReportContactDetails();
        workOrderSurvey.reporterContactDetails.contactNumber = "00000000000";
        dispatch(workOrderRepairObject(workOrderSurvey));
        const worksOrder = new WorksOrderRequest(workOrderSurvey);
        dispatch(workOrderData(worksOrder))
        if (userChosenSurveyReason === "Void Survey" && additionalInfo !== "") {
          dispatch(userChosenContactDetails("00000000000@0"));
          dispatch(userChosenRelationDetails(""));
          dispatch(userChosenContactPhone(""));
          dispatch(userChosenContactName(""));
          props.history.push("/SurveyConfirmationDetails");
        }
        else if (!result) {
          props.history.push("/CustomerDetails");
        }
      }
    } catch (e) {
      console.error(e);
    } 

  };
  const adddescription = (surveyReasonval:any) => {
 if (surveyReasonval) {
          workOrderSurvey.description = userChosenSurveyReason + ". " + surveyReasonval;
        } else {
          workOrderSurvey.description = userChosenSurveyReason + ". " + additionalInfo;
        }
  }
  const UpdateWorkOrder = async (result: boolean) => {
    try {
      dispatch(isEditState(false));
      if (workOrderObject.id.trim().length > 0) {
        const workOrderSurvey = new CurrentRepair();
        enum RepairCauseId {
          "General Wear and Tear" = 1,
          "Vandalism or Damage" = 4,
          "Complaint" = 3,
          "Technical Inspection" = 5,
          "Disrepair" = 6,
          "Right to Improve" = 7,
          "Mutual Exchange" = 8,
          "Leaseholder Improvement Request" = 9,
          "Estate Management Survey" = 10,
          "Damp and Mould Survey" = 13,
        }
        const _premisesTypeId: any =
          PremisesTypeId[assetDetails.assetType as keyof typeof PremisesTypeId];
        workOrderSurvey.repairReason = userChosenSurveyReason;
       adddescription(surveyReasonval)
        workOrderSurvey.additionalInformation = additionalInfo;
        workOrderSurvey.surveyReason = surveyReasonval;
        workOrderSurvey.repairCauseId =
          RepairCauseIds[userChosenSurveyReason as keyof typeof RepairCauseIds];
        workOrderSurvey.priority = priorityCode;
        workOrderSurvey.repairLocation = "Throughout";
        workOrderSurvey.repairLocationId = "15";
        workOrderSurvey.repairType = "survey";
        workOrderSurvey.repairReason = userChosenSurveyReason;
        workOrderSurvey.repairLocation = "Throughout";
        workOrderSurvey.repairLocationId = "15";
        workOrderSurvey.premisesId = assetId;
        if (assetDetails.assetType === "Divided Block") {
          workOrderSurvey.premisesTypeId = "5";
        } else {
          workOrderSurvey.premisesTypeId = _premisesTypeId;
        }
        workOrderSurvey.customerIdentifier = customerID;
        workOrderSurvey.isEmergency = emergencyState

        workOrderSurvey.premisesUniqueReference = assetDetails.uprn;
        const _address = new Address();
        _address.addressLine1 =
          customerDetails?.addresses?.postalAddresses[0]?.addressLine1;
        _address.addressLine2 =
          customerDetails?.addresses?.postalAddresses[0]?.addressLine2;
        _address.addressLine3 =
          customerDetails?.addresses?.postalAddresses[0]?.addressLine3;
        workOrderSurvey.premisesAddress = _address;
        workOrderSurvey.sorCode = userChosenSOR;
        workOrderSurvey.customerName = new CustomerName({
          title: customerDetails?.person?.name?.title,
          givenName: customerDetails?.person?.name?.givenName,
          surname: customerDetails?.person?.name?.surname,
        });
        workOrderSurvey.reportingMethodId =
          surveyReportingMethods[
          selectedreportingMethod as keyof typeof surveyReportingMethods
          ];
        workOrderSurvey.reportingMethod = selectedreportingMethod;
        workOrderSurvey.notifyAll = false;
        workOrderSurvey.eTag = customerDetails?.eTag; // Need to verify
        workOrderSurvey.eligibilityOutcomes = [];
        workOrderSurvey.assetIdentifier = tenanciesData?.premisesIds;
        workOrderSurvey.repairReason = userChosenSurveyReason;
        workOrderSurvey.repairLocation = "Throughout";
        workOrderSurvey.repairLocationId = "15";
        workOrderSurvey.repairCause = userChosenSurveyReason;
        workOrderSurvey.isCatalyst = isCatalyst;
        workOrderSurvey.repairCauseId =
          RepairCauseId[
          userChosenSurveyReason as keyof typeof RepairCauseId
          ];
        const _worksOrderRequest = new WorksOrderRequest(workOrderSurvey);
        const woRequestParameters = _worksOrderRequest.createWorkOrderParameter(
          workOrderSurvey
        );
        woRequestParameters.repairReason = userChosenSurveyReason;
       adddescription(surveyReasonval)
        const apiResponse = await api.createWorkOrderRepair({
          ...woRequestParameters,
        });

        if (apiResponse?.location.length > 0) {
          const workorderLocation = apiResponse?.location.split("/");
          workOrderSurvey.id = workorderLocation[4];
          workOrderSurvey.repairReason = userChosenSurveyReason;
          workOrderSurvey.repairLocation = "Throughout";
          workOrderSurvey.repairLocationId = "15";
          workOrderSurvey.worksOrderIdentifier = workorderLocation[4];
          workOrderSurvey.repairType = "survey";
         adddescription(surveyReasonval)
          dispatch(workOrderRepairObject(workOrderSurvey));
          workOrderSurvey.reporterContactDetails = new ReportContactDetails();
          workOrderSurvey.reporterContactDetails.contactNumber = "00000000000";
          const worksOrder = new WorksOrderRequest(workOrderSurvey);
          dispatch(workOrderData(worksOrder))
          if (userChosenSurveyReason === "Void Survey" && additionalInfo !== "") {
            dispatch(userChosenContactDetails("00000000000@0"));
            props.history.push("/SurveyConfirmationDetails");
          }
          else if (!result) {
            props.history.push("/CustomerDetails");
          }
        }
      } else {
        const _worksOrderRequest = new WorksOrderRequest(workOrderObject);
        const woRequestParameters = _worksOrderRequest.updateWorkOrderParameter(
          workOrderObject
        );
        woRequestParameters.repairReason = userChosenSurveyReason;
        adddescription(surveyReasonval)
        await api.updateWorkOrderRepair(
          woRequestParameters,
          workOrderObject.id,
          "eTag"
        );

        workOrderObject.repairReason =
          userChosenSurveyReason;
        workOrderSurvey.repairType = "survey";
        workOrderSurvey.repairLocation = "Throughout";
        workOrderSurvey.repairLocationId = "15";
        adddescription(surveyReasonval)
        workOrderObject.additionalInformation = workOrderObject[0].additionalInformation;
        dispatch(workOrderRepairObject(workOrderObject));
      }
    } catch (e) {
      console.error(e);
      
      setTimeout(() => {
        props.history.push("/GenericError");
      }, 1000);
    } finally {
      
      setisDisabled(false);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    (async function () {
      try {
        const premiseType =
          assetDetails.assetType === "Block" ||
            assetDetails.assetType === "Estate" ||
            assetDetails.assetType === "Divided Block" ||
            assetDetails.assetType === "Divided block" ||
            assetDetails.assetType === "Estate Area"
            ? "Communal"
            : assetDetails.assetType;
        let isCatalyst = false;
        const responsedata = await api.searchRepairReasons(
          userTypedRepairReasons,
          premiseType,
          isCatalyst
        );
        dispatch(fetchRepairReasonsSelect(responsedata));

        const extractedReasons: string[] = [];

        responsedata.forEach((eachData, key) => {
          const { description } = eachData;
          extractedReasons.push(description);
        });
        dispatch(fetchRepairReasons(extractedReasons));
      } catch (e) {
        console.error(e);
        props.history.push("/GenericError");
      }
    })();
  }, [addresses, userTypedRepairReasons]);

  useEffect(() => {
    alertMstArray = [];
    setLocatioAlert([]);
  }, [userChosenSurveyReason]);

  const getMandatoryData = (data: any) => {
    setChosenHL(data === undefined ? 'No option selected' : data);
  };

  const getAdditionalData = (data: any) => {
    setadditionalInfo(data);
  };

  const getSurveyReason = (data: any) => {
    setsurveyReasonval(data);
  };

  useEffect(() => {
    alertMstArray = [];
    setLocatioAlert([]);
  }, [chosenHL])

  const getDeterminedContractorCall = async () => {
    let determinedContractor: any[] = [];
    let region = assetDetails?.region;
    const raisedDate = new Date();
    const repairTime = raisedDate.getHours().toString();
    const raisedFormattedDate = moment(new Date()).format("YYYY-MM-DD");
    let uprn = assetDetails?.uprn;
    let maintenanceResponsibility: string = userMaintResp;
    let repaiResponsiblity: string = "survey";
    const borough = assetDetails?.borough ? assetDetails?.borough?.trim() : "";
    let isVandalism = false;

    try {
      const options:DeterminedContractorOptions = {
                    identifier: '00000000-0000-0000-0000-000000000000',
                    priority: priorityCode,
                    region,
                    borough,
                    repairType:userChosenSOR?? props.getSorcode,
                    repairTime,
                    uprn,
                    raisedDate:raisedFormattedDate,
                    repairCauseId: RepairCauseIds[
                    userChosenSurveyReason as keyof typeof RepairCauseIds
                    ],
                    maintenanceResponsibility,
                    repairResponsibility:repaiResponsiblity,
                    isVandalism,
                    skipResponsibilityCheckForEMA:skipRespCheckForEMA
                  };
      if (userChosenSurveyReason) {
        determinedContractor =
          await api.getDeterminedContractor(options);
        setContractorName(determinedContractor[0]?.name)
      }
      dispatch(getDeterminedContractorDetails(determinedContractor));
    }
    catch (e) {
      console.log(e)
      if (userChosenSurveyReason === "Keysafe Installation") {
        setErrorMessage(true);
      }
    }
  }


  useEffect(() => {
    if (userChosenSurveyReason !== "" &&
      userChosenSurveyReason !== "No option selected") {
      setisDisabled(false);
      getDeterminedContractorCall();
    }
    alertMstArray = [];
    setLocatioAlert([]);
  }, [userChosenSurveyReason])


  useEffect(() => {
    alertMstArray = [];
    setLocatioAlert([]);
  }, [additionalInfo])

  const question = (data: any) => {
    setValQuestion(data);
  };

  const setAlert = () => {
     if ((userChosenSurveyReason === "" || userChosenSurveyReason === "No option selected") || (userChosenSurveyReason === "Technical Inspection" ? chosenHL === "No option selected" : '') || additionalInfo === "") {
      alertMstArray.push(t("CPR0011"));
      setLocatioAlert(alertMstArray);
      return;
    }
    if (userChosenSurveyReason === "Keysafe Installation") {
      if ((contractorName.length > 1) && (!contractor.has(contractorName))) {
        alertMstArray.push(t("KEY_VALIDATION"));
        setLocatioAlert(alertMstArray);
        return;
      }
      if (errorMessage) {
        if (!contractor.has(contractorName ?? getContractorname)) {
          alertMstArray.push(t("KEY_VALIDATION"));
          setLocatioAlert(alertMstArray);
          return;
        }

      }
    }
  }

  const callPageHandler = async () => {
    setisDisabled(true);
    if (contractorName.length > 0) {
      setErrorMessage(false)
    }

    dispatch(userTypedRepairType('survey'));

    setAlert();

    workOrderSurvey.description = userChosenSurveyReason;
    if (!userChosenResumeRepairValue && !loadDuplicateRepairPageValue) {
      workOrderObject == null ? CreateWorkOrder(false) : UpdateWorkOrder(false);

    }
    else if (userChosenSurveyReason === "Void Survey" && additionalInfo !== "") {
      workOrderSurvey.reporterContactDetails = new ReportContactDetails();
      workOrderSurvey.reporterContactDetails.contactNumber = "00000000000";
      dispatch(userChosenContactDetails('00000000000@0'));
      props.history.push("/SurveyConfirmationDetails");
    }
    else {
      props.history.push("/CustomerDetails");
    }
    if (userChosenSurveyReason === "Keysafe Installation") {
      if ((contractorName.length > 1) && (contractor.has(contractorName))) {
        dispatch(userChosenEmergencyQuestion(''));
      }
    }
    if (userChosenSurveyReason === SurveyTypes.Void_Survey && assetStatusVal === SurveyTypes.VOID) {
      dispatch(userChosenEmergencyQuestion(''));
    }
  };

  return (
    <>
      <div
        className="ml-sm-5 pl-sm-5 pt-2 repair-text container"
        id="repreason-main-div"
      >
        <SurveyReason
          suggestions={fetchedSurveyReasons}
          setisDisabled={setisDisabled}
          locatioAlert={locatioAlert}
          getMandatoryData={getMandatoryData}
          question={question}
          getAdditionalData={getAdditionalData}
          getSurveyReason={getSurveyReason}
          sorCodeValue={props.getSorcode}
          {...props}
        />
      </div>

      <div
        className="flex justify-between items-center pb-4 md:pb-8 container"
        id="repreason-main-btn"
      >
        <Button
          id="btn_repairreason"
          type="button"
          data-testid="btncontinue"
          name="btncontinue"
          disabled={isDisabled}
          onClick={callPageHandler}
          placeholder="btncontinue"
          value="Continue"
          className="button-class"
        >
          {t("continuen_button")}
          <i className="fas fa-angle-right relativetext-white pointer-events-none arrow"></i>
        </Button>
      </div>
    </>
  );
};
export default SurveyDetails;